import calendarIcon from '../../assets/icons/calendar.png';
import numberIcon from '../../assets/icons/numbers.png';
import typographyIcon from '../../assets/icons/typography.png';
import booleanIcon from '../../assets/icons/boolean-toggle.svg';
import integerIcon from '../../assets/icons/integer-123.svg';

export const CANVAS_TABLE_STYLES = {
  COLORS: {
    BLACK: '#000',
    LIGHT_BLUE: '#cee0ff'
  }
};

export const SPECIAL_NULL_STRING = 'null\t';

export const IMAGE_TYPES = {
  string: () => {
    const img = new Image(10, 10);
    img.src = typographyIcon;

    return img;
  },
  float: () => {
    const img = new Image(10, 10);
    img.src = numberIcon;

    return img;
  },
  int: () => {
    const img = new Image(10, 10);
    img.src = integerIcon;

    return img;
  },
  integer: () => {
    const img = new Image(10, 10);
    img.src = integerIcon;

    return img;
  },
  bool: () => {
    const img = new Image(10, 10);
    img.src = booleanIcon;

    return img;
  },
  boolean: () => {
    const img = new Image(10, 10);
    img.src = booleanIcon;

    return img;
  },
  datetime: () => {
    const img = new Image(10, 10);
    img.src = calendarIcon;

    return img;
  },
  date: () => {
    const img = new Image(10, 10);
    img.src = calendarIcon;

    return img;
  }
};
